<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png" />
    <info msg="Welcome to Your Vue.js + TypeScript App" />
    <!-- <HelloWorld msg="Welcome to Your Vue.js + TypeScript App" /> -->
  </div>
</template>

<script lang="ts" setup>
import { defineAsyncComponent } from "vue";
import HelloWorld from "@/components/HelloWorld.vue";
import AboutView from "@/views/AboutView.vue";
const info = defineAsyncComponent({
  loader: () => import("@/components/HelloWorld.vue"),
  loadingComponent: AboutView,
  delay: 200,
  errorComponent: HelloWorld,
  timeout: 500,
});
</script>
